import React from "react";
import { Alert, Button } from "react-bootstrap";
import "./VerificationBanner.css";

const VerificationBanner = ({ isVerified }) => {

    if (isVerified) return null; // hide if verified

    return (
        <Alert key="warning" variant="warning" className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center h4 mb-10px">
                <i className="fas fa-exclamation-triangle fa-2x mr-3" />
                <div>
                    <strong className="mb-2">Verification Required.</strong>
                    <div className="small mt-1">
                        To upload images or videos, please verify your identity.
                    </div>
                </div>
            </div>

            <a
                className="post-btn btn btn-primary"
                target="_blank"
                href={"/document-upload"}
                style={{ top: 0 }}
            >
                Verify
            </a>
        </Alert>

    );
};

export default VerificationBanner;